import   React                         ,
       { useEffect                     ,
         useRef                        ,
         useState                      }  from 'react';

import { useNavigate                   }  from 'react-router-dom';

import { useTypedSelector              }  from '../../../store/useTypeSelector';
import { RootState                     }  from '../../../store/generalReducer'; // Importez le type RootState

import Tab                                from "../../widget/navigation/tab";
import { ACTIVATE_PANEL_EVENT }           from "../../widget/navigation/tab";
import { OPEN_CHANNEL_EVENT, OpenChannelDetail } from "../../block/dashboardV2Managment/ChannelsSection";

import Header                             from "../../block/headerPart/Header"
import Dashboard                          from "../../block/dashboardingManagment/Dashboard";
import DashboardV2                        from "../../block/dashboardV2Managment/DashboardV2";
import SettingsManager                    from "../../block/settingsManagment/SettingsManager";
import MediaList                          from "../../block/mediaManagment/MediaList";
import BroadcastingChannelList            , { BroadcastingChannelListHandle } from "../../block/broadcastingChannelManagment/BroadcastingChannelList";
import UserListV2                         from "../../block/userManagment/UserListV2";
import LegalStructureList                 from "../../block/legalStructureManagment/LegalStructureList";
import ProductList                        from "../../block/productManagment/ProductList";
import SalesCampaignList                  from "../../block/salesCampaignManagment/SalesCampaignList";
import AdsCampaignList                    from "../../block/adsCampaignManagment/AdsCampaignList";
import Stats                              from "../../block/customerFrontEventManagment/Stats";
import PaymentList                        from "../../block/paymentManagment/PaymentList";
//import SalesCampaignSheet2         from "../../block/salesCampaignManagment/SalesCampaignSheet2";
import ThemeEditor                        from "../../block/themeManagment/ThemeEditor";
import AdminList                          from "../../block/adminManagment/AdminList";
import LegalFooter                        from "../../widget/navigation/LegalFooter";
import CookieConsent                      from "../../widget/navigation/CookieConsent";
import BetaApplicationList                from "../../block/betaApplicationManagment/BetaApplicationList";
import { getBetaApplications, BETA_APPLICATIONS_CHANGED_EVENT } from "../../../backendServices/betaApplicationManagment/api";
import PanicPanel                         from "../../block/systemManagment/PanicPanel";
import ModerationPanel                     from "../../block/chatModerationManagment/ModerationPanel";
import StatisticsV2                     from "../../block/statisticsV2Managment/StatisticsV2";
//import ChatManagment                       from "../../block/chatManagment/ChatManagment";


const mainChoices = [
  // {
    // title: "Abonnement",
    // panelKey: "subscriptionManagment",
    // component: <ProductList productType='Offres'/>,
    // booleanKeys: ["SVOD","Diffusion","Boutique"],
  // },
  // Les catégories médias / chaînes / produits ne sont plus des onglets : chaque écran de liste
  // ouvre son gestionnaire de catégories via un bouton dédié dans son en-tête.
  {
    title: "Vidéo",
    panelKey: "mediaManagment",
    component: <MediaList />,
    booleanKeys: ["All"]// booleanKeys: ["SVOD"],
  },
  {
    title: "Chaînes",
    panelKey: "broadcastingManagment",
    component: <BroadcastingChannelList />,
    booleanKeys: ["All"], // booleanKeys: ["Diffusion"],
    keepMounted: true
  },
  // Chat en direct (trié par l'IA de Google, plusieurs chaînes à la fois) et
  // commentaires vidéo. Reste monté : le relevé de la file, son signal sonore et
  // le compteur du titre continuent pendant qu'on est sur un autre onglet.
  {
    title: "Modération",
    panelKey: "commentModeration",
    component: <ModerationPanel />,
    booleanKeys: ["All"],
    keepMounted: true
  },
  // Statistiques V2 : visibles de tous les créateurs, chacun ne voyant que ses
  // chaînes et ses vidéos (le Superadmin voit tout).
  {
    title: "Statistiques",
    panelKey: "statisticsV2Managment",
    component: <StatisticsV2 />,
    booleanKeys: ["All"],
  },
  // Achats / Mes abonnements ne sont plus des onglets du menu général : ce sont
  // désormais des sections de la fiche créateur (AdminSheet), au même titre que
  // Tableau de bord — cf. AdminSheet.tsx.
  // {
  //   title: "Chat",
  //   panelKey: "tchatManagment",
  //   component: <ChatManagment />,
  //   booleanKeys: ["All"]// booleanKeys: ["Chat"],
  // },

  // {
    // title: "Statistiques live",
    // panelKey: "liveStats",
    // component: <LiveStats />,
    // booleanKeys: ["Diffusion"], 
  // },
  // {
    // title: "Statistiques replay",
    // panelKey: "replayStats",
    // component: <ReplayStats />,
    // booleanKeys: ["SVOD"],
  // },
  // {
    // title: "QR code",
    // panelKey: "QRcode",
    // component: <SalesCampaignSheet2 />,
    // booleanKeys: ["All"],
  // },
  
  
  // {
    // title: "Produuits (temp)",
    // panelKey: "PrioductManagment",
    // component: <ProductList/>,
    // booleanKeys: ["All"],
  // },  
  ];



export const Desktop = () => {

  const navigate = useNavigate();

  const broadcastingChannelListRef = useRef<BroadcastingChannelListHandle>(null);

  // Ce qui attend dans l'écran Modération (messages du chat à valider, et
  // signalements à traiter pour un super-admin), pour le titre de son onglet.
  const [ chatPending , setChatPending ] = useState(0);

  // Candidatures de bêta-testeur en attente de décision : pastille rouge sur l'onglet (super-admin).
  const [ betaPending , setBetaPending ] = useState(0);

  const { authentication } = useTypedSelector((state: RootState) => state.authenticationReducer);
  const { booleanMap     } = useTypedSelector((state: RootState) => state.booleanMapReducer);

  // Boutons « Régie » et « Fiche » du Dashboard (2026-10-17) : passer à la section
  // Chaînes, puis ouvrir la fiche de la chaîne sur le bon onglet. La liste n'est montée
  // qu'une fois la section affichée : on la réessaie quelques fois avant d'abandonner.
  useEffect(() => {
    const timers: number[] = [];
    const onOpenChannel = (e: Event) => {
      const detail = (e as CustomEvent<OpenChannelDetail>).detail;
      if (!detail?.id) return;
      window.dispatchEvent(new CustomEvent(ACTIVATE_PANEL_EVENT, { detail: { panelKey: 'broadcastingManagment' } }));
      const tabIndex = detail.tab === 'regie' ? 3 : 0;
      const tryOpen = (attempt: number) => {
        if (broadcastingChannelListRef.current) { broadcastingChannelListRef.current.openChannel(detail.id, tabIndex); return; }
        if (attempt < 20) timers.push(window.setTimeout(() => tryOpen(attempt + 1), 50));
      };
      tryOpen(0);
    };
    window.addEventListener(OPEN_CHANNEL_EVENT, onOpenChannel);
    return () => { window.removeEventListener(OPEN_CHANNEL_EVENT, onOpenChannel); timers.forEach(t => window.clearTimeout(t)); };
  }, []);

  useEffect(() => {

         if ( authentication.login === "" ||
              authentication.token === "" )
          {
           navigate ("/");
          }

  }, [] );

  const isSuperadmin = authentication.admin?.role === 'ADMIN';

  useEffect(() => {
    if (!isSuperadmin) { setBetaPending(0); return; }
    let cancelled = false;
    const refresh = () => {
      getBetaApplications('pending').then(r => { if (!cancelled && r.code === 1) setBetaPending(r.payload.length); }).catch(() => {});
    };
    refresh();
    const timer = window.setInterval(refresh, 60000);
    window.addEventListener(BETA_APPLICATIONS_CHANGED_EVENT, refresh);
    return () => { cancelled = true; window.clearInterval(timer); window.removeEventListener(BETA_APPLICATIONS_CHANGED_EVENT, refresh); };
  }, [isSuperadmin]);

  // Dashboard : le superadmin voit tout ; un créateur n'a que la vue « Diffusion » de ses chaînes (l'API le limite).
  const dashboardChoice = {
    title: isSuperadmin ? "Dashboard" : "Audience",
    panelKey: "dashboardV2Managment",
    component: <DashboardV2 />,
    booleanKeys: ["All"],
  };

  const choices = isSuperadmin
                    ? [ dashboardChoice,
  ...mainChoices,
  {
    title: "Tableau de bord",
    panelKey: "dashboardingManagment",
    component: <Dashboard />,
    booleanKeys: ["All"], 
  },
  {
    title: "Produits",
    panelKey: "productList",
    component: <ProductList/>,
    booleanKeys: ["All"]// booleanKeys: ["SVOD","Diffusion","Boutique"], 
  },
  {
    title: "Campagnes de ventes",
    panelKey: "salesCampaignList",
    component: <SalesCampaignList />,
    booleanKeys: ["All"]// booleanKeys: ["Campagne QRcode/CTA"],
  },
  // {
  //   title: "Utilisateurs",
  //   panelKey: "userList",
  //   component: <UserList />,
  //   booleanKeys: ["All"]// booleanKeys: ["VOD","Boutique"],
  // },
  {
    title: "Utilisateurs",
    panelKey: "userListV2",
    component: <UserListV2 />,
    booleanKeys: ["All"]
  },

                        {
    title: "Annonceurs",
    panelKey: "legalStructureList",
    component: <LegalStructureList />,
    booleanKeys: ["All"]// booleanKeys: ["Gestion des annonceurs"],
  },
  {
    title: "Campagnes annonceurs",
    panelKey: "adsCampaignList",
    component: <AdsCampaignList />,
    booleanKeys: ["All"]// booleanKeys: ["Gestion des annonceurs"],
  },
  {
    title: "Statistiques",
    panelKey: "Stats",
    component: <Stats />,
    booleanKeys: ["All"],
  },
  {
    title: "Commandes",
    panelKey: "orders",
    component: <PaymentList />,
    booleanKeys: ["All"]// booleanKeys: ["SVOD","Boutique"],
  },
  {
    title: "Sondages",
    panelKey: "pollsManagment",
    component: <SettingsManager />,
    booleanKeys: ["All"]// booleanKeys: ["Sondage"], 
  },
  {
    title: "Chat",
    panelKey: "tchatManagment",
    component: <SettingsManager />,
    booleanKeys: ["All"]// booleanKeys: ["Chat"], 
  },
  {
    title: "IA",
    panelKey: "iaManagment",
    component: <SettingsManager />,
    booleanKeys: ["All"]// booleanKeys: ["Compagnon IA"],
  },

                        {
                          title:       "Créateur",
                          panelKey:    "adminManagment",
                          component:   <AdminList />,
                          booleanKeys: ["All"]
                        },

                        // Candidatures de bêta-testeur — réservé au super-admin : liste, fiche,
                        // acceptation (qui crée le compte créateur) et refus.
                        {
                          title:       "Bêta-testeur",
                          panelKey:    "betaApplicationManagment",
                          component:   <BetaApplicationList />,
                          booleanKeys: ["All"]
                        },

                        {
                          title:       "Paramètres",
                          panelKey:    "settingsManagment",
                          component:   <ThemeEditor />,
                          booleanKeys: ["All"]
                        },

                        // Arrêt général de la diffusion — réservé au super-admin, comme
                        // l'onglet Créateur juste au-dessus. Le bouton n'agit qu'après
                        // confirmation : ouvrir l'onglet ne coupe rien.
                        {
                          title:       "Panic",
                          panelKey:    "panicManagment",
                          component:   <PanicPanel />,
                          booleanKeys: ["All"]
                        }
                      ]
                    : [ dashboardChoice, ...mainChoices ];

  // Onglets Superadmin masqués (2026-10-19) : code conservé, il suffit de retirer
  // la clé de cette liste pour les réafficher.
  const hiddenPanelKeys = ["dashboardingManagment", "legalStructureList", "adsCampaignList",
                           "Stats", "orders", "pollsManagment", "tchatManagment", "iaManagment",
                           "productList", 
						   "salesCampaignList",
                           // Statistiques : plus d'onglet pour les créateurs (2026-10-31).
                           ...(isSuperadmin ? [] : ["statisticsV2Managment"])];

  const filteredChoices = choices.filter(choice => !hiddenPanelKeys.includes(choice.panelKey)).filter(choice =>
         choice.booleanKeys.includes("All") ||
         choice.booleanKeys.some(key => booleanMap[key])
  ).map(choice =>
    choice.panelKey === "broadcastingManagment"
      ? { ...choice,
          component:  <BroadcastingChannelList ref={broadcastingChannelListRef} />,
          onActivate: () => broadcastingChannelListRef.current?.goToList(),
        }
      : choice.panelKey === "commentModeration"
      ? { ...choice,
          title:     chatPending > 0 ? `Modération (${chatPending})` : choice.title,
          badge:     chatPending > 0,
          component: <ModerationPanel onPendingCount={setChatPending} />,
        }
      : choice.panelKey === "betaApplicationManagment"
      ? { ...choice, badge: betaPending > 0 }
      : choice
  );

  return (
    <>
     <Tab mainChoices   = {filteredChoices}
	      defaultActivePanel="broadcastingManagment"
          position      = "top"
          topNav        = {true}
          rightPanelKeys = {isSuperadmin ? ["settingsManagment", "panicManagment"] : undefined}
          headerContent = {<Header/>}
          footerContent = {<LegalFooter/>} />
     <CookieConsent />
    </>
  )
};

export default Desktop;
